import config from "@/config/default";

// 智能评估通用类目图标映射（类型名 -> 图标文件名）
// README: 通用类目 iconUrl 为 null，前端按类型名取此映射展示原图标；个性类目用接口返回的 iconUrl
export const IntelligentTypeIconMap: Record<string, string> = {
  "肩颈状态": "20251015165654shoulder.png",
  "腰椎状态": "20251015165635waist.png",
  "肠胃状态-排便次数": "20251015165609feces.png",
  "肠胃状态-小便自测": "20251015165546toilet.png",
  "肠胃状态-其他": "20251015165517stomach.png",
  "肝胆状态": "20251015165451liver.png",
  "肾部状态": "20251015165427kidney.png",
  "月经状态": "20251015165317menstrual.png",
  "睡眠状态": "20251015165302sleep.png",
  "心脑血管状态": "20251015165242heart.png",
  "疾病史": "20251015165145history.png",
  "生理期": "20251015165110period.png",
  "到店途径": "20251015165004way.png",
};

// 获取通用类目图标完整地址；个性类目应使用接口返回的 iconUrl，不经过此方法
export function getIntelligentTypeIconUrl(typeName: string): string {
  const fileName = IntelligentTypeIconMap[typeName];
  return fileName ? `${config.uploadImgUrl}icon/${fileName}` : "";
}
